import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NodeApiService} from '../../network/online/node/node-api.service';
import {ConnectionApiService} from '../../network/online/connection/connection-api.service';
import {RoutingRuleApiService} from '../../routing/routing-rule/routing-rule-api.service';
import {VoipPeerApiService} from '../../network/online/voip-peer/voip-peer-api.service';
import {PeerConnectionApiService} from '../../peer-connection/peer-connection-api.service';
import {RoutingGroupApiService} from '../../routing-group/routing-group-api.service';
import {CustomersApiService} from '../../customers/customers-api.service';
import {RoutingServersSettingsApiService} from '../../routing-servers/routing-servers-settings-api.service';

@Injectable({
  providedIn: 'root'
})
export class ThresholdApiService {

  constructor(private http: HttpClient,
              private nodeApiService: NodeApiService,
              private peerConnectionApiService: PeerConnectionApiService,
              private connectionApiService: ConnectionApiService,
              private routingRuleApiService: RoutingRuleApiService,
              private routingGroupApiService: RoutingGroupApiService,
              private customersApiService: CustomersApiService,
              private voipPeerApiService: VoipPeerApiService,
              private routingServersSettingsApiService: RoutingServersSettingsApiService) { }

  readonly thresholdUrl = 'statistics/threshold';
  readonly thresholdStructureUrl = `${this.thresholdUrl}/structure`;

  public getExternalData(): Promise<any> {
    return Promise.all([
      this.nodeApiService.getNodes(),
      this.peerConnectionApiService.getPCons(),
    this.connectionApiService.getConnections(),
    this.routingGroupApiService.getGroupsSlim(),
    this.customersApiService.getCustomers().toPromise(),
    this.voipPeerApiService.getVoipPeers(),
    this.routingServersSettingsApiService.getRoutingServers().toPromise()]);
  }

  public getThresholdStructure(): Promise<any> {
    return this.http.get(this.thresholdStructureUrl).toPromise();
  }

  public getThresholds(): Promise<any> {
    return this.http.get(this.thresholdUrl).toPromise();
  }

  public addThreshold(threshold): Promise<any> {
    return this.http.post(this.thresholdUrl, threshold).toPromise();
  }

  public editThreshold(thresholdId, threshold): Promise<any> {
    return this.http.put(`${this.thresholdUrl}/${thresholdId}`, threshold).toPromise();
  }

  public deleteThreshold(thresholdId): Promise<any> {
    return this.http.delete(`${this.thresholdUrl}/${thresholdId}`).toPromise();
  }
}
